<template>
  <Row>
    <Col span="24">
      <div class="res_div1">
        <p class="res_div_p">{{ NewsData.title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp">
            发布时间：{{ NewsData.publishDate | formatDate }}
          </span>
        </div>
        <div
          class="div_img01"
          v-for="(item, index) in NewsData.detailList"
          :key="index"
        >
          <img
            v-for="(items, idnex) in item.headUrl.split(',')"
            :key="idnex"
            v-if="item.headUrl !== '' && item.type == 2"
            :src="items"
            alt="暂无照片"
          />
          <video
            style="width: 100%"
            v-for="(items, idnex) in item.headUrl.split(',')"
            :key="idnex"
            v-if="item.headUrl !== '' && item.type == 3"
            :src="items"
            controls="controls"
            autoplay
          ></video>
          <p class="font_div">{{ item.content }}</p>
          <img
            v-for="(items, idnex) in item.footUrl.split(',')"
            :key="idnex"
            v-if="item.footUrl !== '' && item.type == 2"
            :src="items"
            alt="暂无照片"
          />
          <video
            style="width: 100%"
            v-for="(items, idnex) in item.headUrl.split(',')"
            :key="idnex"
            v-if="item.footUrl !== '' && item.type == 3"
            :src="items"
            controls="controls"
            autoplay
          ></video>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
import { formatDate } from "@/utils/filters";
export default {
  filters: {
    formatDate(time) {
      if (time == undefined) {
        return;
      } else {
        time = time;
        let date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      }
    },
  },
  data() {
    return {
      NewsData: [],
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    this.getContentByPages();
  },
  methods: {
    // 获取新闻列表
    getContentByPages() {
      this.$axios
        .get(
          "/api/preHandleCtrl/getContentDetailListByMasterId?masterId=" +
            this.id
        )
        .then((res) => {
          this.NewsData = res.data.data;
        });
    },
  },
};
</script>

<style scoped>
.res_div1 {
  width: 100%;
  margin-top: 20px;
  /* text-align: center; */
}

.res_div1 img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
  text-indent: 2em;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 100%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsDetails.vue